export const WELLO_POINT_UNIT = '원';

export const formatWelloPoint = (amount: number, { signed = false } = {}) => {
  const sign = amount < 0 ? '-' : signed && amount > 0 ? '+' : '';

  return `${sign}${Math.abs(amount).toLocaleString('ko-KR')}${WELLO_POINT_UNIT}`;
};
